var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuturePayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 13.541,
    viewBox: "0 0 15.999 13.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_335",
    "data-name": "Uni\\xE3o 335",
    d: "M-1324,4101.541a1.021,1.021,0,0,1-1-1.04v-9.355a1.02,1.02,0,0,1,1-1.039h8.335a.51.51,0,0,1,.5.519.511.511,0,0,1-.5.52H-1324v2.079h8.335a.511.511,0,0,1,.5.52.511.511,0,0,1-.5.52H-1324v6.236h14v-5.848a.511.511,0,0,1,.5-.52.511.511,0,0,1,.5.52v5.848a1.021,1.021,0,0,1-1,1.04Zm1.5-4.159a.509.509,0,0,1-.5-.519.51.51,0,0,1,.5-.52h2a.511.511,0,0,1,.5.52.509.509,0,0,1-.5.519Zm10.1-2.828v-5l-1.637,1.362a.473.473,0,0,1-.682-.079.519.519,0,0,1,.076-.709l2.425-2.016a.471.471,0,0,1,.606,0l2.426,2.016a.518.518,0,0,1,.075.709.473.473,0,0,1-.682.079l-1.637-1.362v5a.5.5,0,0,1-.485.5A.5.5,0,0,1-1312.4,4094.555Z",
    transform: "translate(1325 -4088)",
    fill: "#142249"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturePayment);
export default __webpack_public_path__ + "static/media/futurePayment.2df08955ba2c7b0ad2cec7ce732ef92a.svg";
export { ForwardRef as ReactComponent };